import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useBlogDetailsQuery } from '../../../helpers/blogApi'
import Loader from "../../../components/Loader/Loader"
import { CalendarIcon } from '@heroicons/react/24/outline'
import HtmlWithDefaultStyles from '../../../components/DangerousHtml/HtmlWithDefaultStyles'
import { Helmet } from 'react-helmet'
import { motion } from 'framer-motion';
import { usePressDetailsQuery } from '../../../helpers/pressNewsApi'


const options = {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
};

const PresshqDeatils = () => {

    const { slug } = useParams()

    const [day, setday] = useState('')
    const [month, setmonth] = useState('')
    const [year, setyear] = useState('')

    const { data, isFetching } = usePressDetailsQuery(slug)

    useEffect(() => {
        if (data) {
            const formattedDate = new Date(data.press[0].createdAt).toLocaleDateString('en-US', options);
            const [month, day, year] = formattedDate.split(' ');
            setmonth(month)
            setday(day)
            setyear(year)
        }
    }, [data])


    return (

        <div className="dark:bg-gray-900 transition-all duration-700">
            <div className=' pt-[45px] md:pt-[62px]'>
                {isFetching ? <Loader text={'Loading details...'} height='80vh' /> : (
                    <div>
                        <Helmet >
                            <title> CodeZone | PressHQ | {data.press[0].slug}</title>
                        </Helmet>
                        <div className='relative min-h-[40vh] md:min-h-[50vh]'>
                            <div className='absolute inset-0'>
                                <img
                                    src={data.press[0].image}
                                    alt='img'
                                    className='object-cover w-full h-full' />
                            </div>
                            <div className='absolute inset-0 bg-black opacity-50' />
                            <div className='absolute inset-0'>
                                <div className='max-w-screen-xl mx-auto px-4 py-3 flex flex-col justify-center h-full'>
                                    <div className='max-w-[700px]'>
                                        <motion.div
                                            whileInView={{ x: [-300, 0], opacity: [0, 1] }}
                                            transition={{ duration: 1.3 }}
                                            viewport={{ once: true }}
                                            initial='hidden'
                                            style={{ opacity: 0 }}


                                        >
                                            <h1 className='text-white text-sm sm:text-xl md:text-2xl font-bold z-40'>
                                                {data.press[0].title}
                                            </h1>
                                            <div>
                                                <div className='flex items-center gap-1 group w-fit mt-4'>
                                                    <CalendarIcon className='text-white h-3 sm:h-4 group-hover:text-green-500 duration-700' />
                                                    <h6 className='text-white text-[14px] sm:text-xs'>
                                                        <span className='group-hover:text-green-500 duration-700'>{month} {day} </span> <span className='group-hover:text-yellow-500 duration-700'>{year}</span>
                                                    </h6>
                                                </div>
                                            </div>
                                        </motion.div>

                                    </div>
                                </div>

                            </div>
                        </div>
                        <motion.div
                            whileInView={{ y: [100, 0], opacity: [0, 1] }}
                            transition={{ duration: 1.0, delay: 0.3 }}
                            viewport={{ once: true }}
                            initial='hidden'
                            style={{ opacity: 0 }}
                        >
                            <div className='max-w-screen-xl mx-auto px-4 py-5 md:py-10 dark:text-white'>
                                <HtmlWithDefaultStyles htmlString={data.press[0].desc} />
                            </div>
                        </motion.div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default PresshqDeatils